module.exports = __webpack_public_path__ + "img/norse-Unselected.971066ac.webp";